// GERADO por scripts/gerar-localidades.mjs — não edite à mão.
// Fonte: IBGE (servicodados.ibge.gov.br). Atualizado em 2026-08-25.

export interface Pais {
  codigo: string;
  nome: string;
}

export const PAISES: Pais[] = [
  {
    "codigo": "AF",
    "nome": "Afeganistão"
  },
  {
    "codigo": "ZA",
    "nome": "África do Sul"
  },
  {
    "codigo": "AL",
    "nome": "Albânia"
  },
  {
    "codigo": "DE",
    "nome": "Alemanha"
  },
  {
    "codigo": "AD",
    "nome": "Andorra"
  },
  {
    "codigo": "AO",
    "nome": "Angola"
  },
  {
    "codigo": "AG",
    "nome": "Antígua e Barbuda"
  },
  {
    "codigo": "SA",
    "nome": "Arábia Saudita"
  },
  {
    "codigo": "DZ",
    "nome": "Argélia"
  },
  {
    "codigo": "AR",
    "nome": "Argentina"
  },
  {
    "codigo": "AM",
    "nome": "Armênia"
  },
  {
    "codigo": "AU",
    "nome": "Austrália"
  },
  {
    "codigo": "AT",
    "nome": "Áustria"
  },
  {
    "codigo": "AZ",
    "nome": "Azerbaijão"
  },
  {
    "codigo": "BS",
    "nome": "Bahamas"
  },
  {
    "codigo": "BD",
    "nome": "Bangladesh"
  },
  {
    "codigo": "BB",
    "nome": "Barbados"
  },
  {
    "codigo": "BH",
    "nome": "Barein"
  },
  {
    "codigo": "BY",
    "nome": "Belarus"
  },
  {
    "codigo": "BE",
    "nome": "Bélgica"
  },
  {
    "codigo": "BZ",
    "nome": "Belize"
  },
  {
    "codigo": "BJ",
    "nome": "Benin"
  },
  {
    "codigo": "BO",
    "nome": "Bolívia"
  },
  {
    "codigo": "BA",
    "nome": "Bósnia e Herzegovina"
  },
  {
    "codigo": "BW",
    "nome": "Botsuana"
  },
  {
    "codigo": "BR",
    "nome": "Brasil"
  },
  {
    "codigo": "BN",
    "nome": "Brunei"
  },
  {
    "codigo": "BG",
    "nome": "Bulgária"
  },
  {
    "codigo": "BF",
    "nome": "Burkina Faso"
  },
  {
    "codigo": "BI",
    "nome": "Burundi"
  },
  {
    "codigo": "BT",
    "nome": "Butão"
  },
  {
    "codigo": "CV",
    "nome": "Cabo Verde"
  },
  {
    "codigo": "CM",
    "nome": "Camarões"
  },
  {
    "codigo": "KH",
    "nome": "Camboja"
  },
  {
    "codigo": "CA",
    "nome": "Canadá"
  },
  {
    "codigo": "QA",
    "nome": "Catar"
  },
  {
    "codigo": "KZ",
    "nome": "Cazaquistão"
  },
  {
    "codigo": "TD",
    "nome": "Chade"
  },
  {
    "codigo": "CL",
    "nome": "Chile"
  },
  {
    "codigo": "CN",
    "nome": "China"
  },
  {
    "codigo": "CY",
    "nome": "Chipre"
  },
  {
    "codigo": "CO",
    "nome": "Colômbia"
  },
  {
    "codigo": "KM",
    "nome": "Comores"
  },
  {
    "codigo": "CI",
    "nome": "Costa do Marfim"
  },
  {
    "codigo": "CR",
    "nome": "Costa Rica"
  },
  {
    "codigo": "HR",
    "nome": "Croácia"
  },
  {
    "codigo": "CU",
    "nome": "Cuba"
  },
  {
    "codigo": "DK",
    "nome": "Dinamarca"
  },
  {
    "codigo": "DJ",
    "nome": "Djibouti"
  },
  {
    "codigo": "DM",
    "nome": "Dominica"
  },
  {
    "codigo": "EG",
    "nome": "Egito"
  },
  {
    "codigo": "SV",
    "nome": "El Salvador"
  },
  {
    "codigo": "AE",
    "nome": "Emirados Árabes Unidos"
  },
  {
    "codigo": "EC",
    "nome": "Equador"
  },
  {
    "codigo": "ER",
    "nome": "Eritreia"
  },
  {
    "codigo": "SK",
    "nome": "Eslováquia"
  },
  {
    "codigo": "SI",
    "nome": "Eslovênia"
  },
  {
    "codigo": "ES",
    "nome": "Espanha"
  },
  {
    "codigo": "US",
    "nome": "Estados Unidos da América"
  },
  {
    "codigo": "EE",
    "nome": "Estônia"
  },
  {
    "codigo": "SZ",
    "nome": "Eswatini"
  },
  {
    "codigo": "ET",
    "nome": "Etiópia"
  },
  {
    "codigo": "FJ",
    "nome": "Fiji"
  },
  {
    "codigo": "PH",
    "nome": "Filipinas"
  },
  {
    "codigo": "FI",
    "nome": "Finlândia"
  },
  {
    "codigo": "FR",
    "nome": "França"
  },
  {
    "codigo": "GA",
    "nome": "Gabão"
  },
  {
    "codigo": "GM",
    "nome": "Gâmbia"
  },
  {
    "codigo": "GH",
    "nome": "Gana"
  },
  {
    "codigo": "GE",
    "nome": "Geórgia"
  },
  {
    "codigo": "GD",
    "nome": "Granada"
  },
  {
    "codigo": "GR",
    "nome": "Grécia"
  },
  {
    "codigo": "GT",
    "nome": "Guatemala"
  },
  {
    "codigo": "GY",
    "nome": "Guiana"
  },
  {
    "codigo": "GN",
    "nome": "Guiné"
  },
  {
    "codigo": "GQ",
    "nome": "Guiné Equatorial"
  },
  {
    "codigo": "GW",
    "nome": "Guiné-Bissau"
  },
  {
    "codigo": "HT",
    "nome": "Haiti"
  },
  {
    "codigo": "HN",
    "nome": "Honduras"
  },
  {
    "codigo": "HU",
    "nome": "Hungria"
  },
  {
    "codigo": "YE",
    "nome": "Iêmen"
  },
  {
    "codigo": "MH",
    "nome": "Ilhas Marshall"
  },
  {
    "codigo": "SB",
    "nome": "Ilhas Salomão"
  },
  {
    "codigo": "IN",
    "nome": "Índia"
  },
  {
    "codigo": "ID",
    "nome": "Indonésia"
  },
  {
    "codigo": "IR",
    "nome": "Irã"
  },
  {
    "codigo": "IQ",
    "nome": "Iraque"
  },
  {
    "codigo": "IE",
    "nome": "Irlanda"
  },
  {
    "codigo": "IS",
    "nome": "Islândia"
  },
  {
    "codigo": "IL",
    "nome": "Israel"
  },
  {
    "codigo": "IT",
    "nome": "Itália"
  },
  {
    "codigo": "JM",
    "nome": "Jamaica"
  },
  {
    "codigo": "JP",
    "nome": "Japão"
  },
  {
    "codigo": "JO",
    "nome": "Jordânia"
  },
  {
    "codigo": "KI",
    "nome": "Kiribati"
  },
  {
    "codigo": "KW",
    "nome": "Kuwait"
  },
  {
    "codigo": "LA",
    "nome": "Laos"
  },
  {
    "codigo": "LS",
    "nome": "Lesoto"
  },
  {
    "codigo": "LV",
    "nome": "Letônia"
  },
  {
    "codigo": "LB",
    "nome": "Líbano"
  },
  {
    "codigo": "LR",
    "nome": "Libéria"
  },
  {
    "codigo": "LY",
    "nome": "Líbia"
  },
  {
    "codigo": "LI",
    "nome": "Liechtenstein"
  },
  {
    "codigo": "LT",
    "nome": "Lituânia"
  },
  {
    "codigo": "LU",
    "nome": "Luxemburgo"
  },
  {
    "codigo": "MK",
    "nome": "Macedônia do Norte"
  },
  {
    "codigo": "MG",
    "nome": "Madagascar"
  },
  {
    "codigo": "MY",
    "nome": "Malásia"
  },
  {
    "codigo": "MW",
    "nome": "Malauí"
  },
  {
    "codigo": "MV",
    "nome": "Maldivas"
  },
  {
    "codigo": "ML",
    "nome": "Mali"
  },
  {
    "codigo": "MT",
    "nome": "Malta"
  },
  {
    "codigo": "MA",
    "nome": "Marrocos"
  },
  {
    "codigo": "MU",
    "nome": "Maurício"
  },
  {
    "codigo": "MR",
    "nome": "Mauritânia"
  },
  {
    "codigo": "MX",
    "nome": "México"
  },
  {
    "codigo": "MM",
    "nome": "Mianmar"
  },
  {
    "codigo": "FM",
    "nome": "Micronésia"
  },
  {
    "codigo": "MZ",
    "nome": "Moçambique"
  },
  {
    "codigo": "MD",
    "nome": "Moldávia"
  },
  {
    "codigo": "MC",
    "nome": "Mônaco"
  },
  {
    "codigo": "MN",
    "nome": "Mongólia"
  },
  {
    "codigo": "ME",
    "nome": "Montenegro"
  },
  {
    "codigo": "NA",
    "nome": "Namíbia"
  },
  {
    "codigo": "NR",
    "nome": "Nauru"
  },
  {
    "codigo": "NP",
    "nome": "Nepal"
  },
  {
    "codigo": "NI",
    "nome": "Nicarágua"
  },
  {
    "codigo": "NE",
    "nome": "Niger"
  },
  {
    "codigo": "NG",
    "nome": "Nigéria"
  },
  {
    "codigo": "NO",
    "nome": "Noruega"
  },
  {
    "codigo": "NZ",
    "nome": "Nova Zelândia"
  },
  {
    "codigo": "OM",
    "nome": "Omã"
  },
  {
    "codigo": "NL",
    "nome": "Países Baixos"
  },
  {
    "codigo": "PW",
    "nome": "Palau"
  },
  {
    "codigo": "PA",
    "nome": "Panamá"
  },
  {
    "codigo": "PG",
    "nome": "Papua Nova Guiné"
  },
  {
    "codigo": "PK",
    "nome": "Paquistão"
  },
  {
    "codigo": "PY",
    "nome": "Paraguai"
  },
  {
    "codigo": "PE",
    "nome": "Peru"
  },
  {
    "codigo": "PL",
    "nome": "Polônia"
  },
  {
    "codigo": "PT",
    "nome": "Portugal"
  },
  {
    "codigo": "KE",
    "nome": "Quênia"
  },
  {
    "codigo": "KG",
    "nome": "Quirguistão"
  },
  {
    "codigo": "GB",
    "nome": "Reino Unido"
  },
  {
    "codigo": "CF",
    "nome": "República Centro-Africana"
  },
  {
    "codigo": "KR",
    "nome": "República da Coreia"
  },
  {
    "codigo": "CD",
    "nome": "República Democrática do Congo"
  },
  {
    "codigo": "CG",
    "nome": "República do Congo"
  },
  {
    "codigo": "DO",
    "nome": "República Dominicana"
  },
  {
    "codigo": "KP",
    "nome": "República Popular Democrática da Coreia"
  },
  {
    "codigo": "CZ",
    "nome": "República Tcheca"
  },
  {
    "codigo": "RO",
    "nome": "Romênia"
  },
  {
    "codigo": "RW",
    "nome": "Ruanda"
  },
  {
    "codigo": "RU",
    "nome": "Rússia (Federação Russa)"
  },
  {
    "codigo": "WS",
    "nome": "Samoa"
  },
  {
    "codigo": "SM",
    "nome": "San Marino"
  },
  {
    "codigo": "LC",
    "nome": "Santa Lúcia"
  },
  {
    "codigo": "KN",
    "nome": "São Cristóvão e Nevis"
  },
  {
    "codigo": "ST",
    "nome": "São Tomé e Príncipe"
  },
  {
    "codigo": "VC",
    "nome": "São Vicente e Granadinas"
  },
  {
    "codigo": "SC",
    "nome": "Seichelles"
  },
  {
    "codigo": "SN",
    "nome": "Senegal"
  },
  {
    "codigo": "SL",
    "nome": "Serra Leoa"
  },
  {
    "codigo": "RS",
    "nome": "Sérvia"
  },
  {
    "codigo": "SG",
    "nome": "Singapura"
  },
  {
    "codigo": "SY",
    "nome": "Síria"
  },
  {
    "codigo": "SO",
    "nome": "Somália"
  },
  {
    "codigo": "LK",
    "nome": "Sri Lanka"
  },
  {
    "codigo": "SD",
    "nome": "Sudão"
  },
  {
    "codigo": "SS",
    "nome": "Sudão do Sul"
  },
  {
    "codigo": "SE",
    "nome": "Suécia"
  },
  {
    "codigo": "CH",
    "nome": "Suíça"
  },
  {
    "codigo": "SR",
    "nome": "Suriname"
  },
  {
    "codigo": "TJ",
    "nome": "Tadjiquistão"
  },
  {
    "codigo": "TH",
    "nome": "Tailândia"
  },
  {
    "codigo": "TZ",
    "nome": "Tanzânia"
  },
  {
    "codigo": "TL",
    "nome": "Timor-Leste"
  },
  {
    "codigo": "TG",
    "nome": "Togo"
  },
  {
    "codigo": "TO",
    "nome": "Tonga"
  },
  {
    "codigo": "TT",
    "nome": "Trinidad e Tobago"
  },
  {
    "codigo": "TN",
    "nome": "Tunísia"
  },
  {
    "codigo": "TM",
    "nome": "Turcomenistão"
  },
  {
    "codigo": "TR",
    "nome": "Turquia"
  },
  {
    "codigo": "TV",
    "nome": "Tuvalu"
  },
  {
    "codigo": "UA",
    "nome": "Ucrânia"
  },
  {
    "codigo": "UG",
    "nome": "Uganda"
  },
  {
    "codigo": "UY",
    "nome": "Uruguai"
  },
  {
    "codigo": "UZ",
    "nome": "Uzbequistão"
  },
  {
    "codigo": "VU",
    "nome": "Vanuatu"
  },
  {
    "codigo": "VE",
    "nome": "Venezuela"
  },
  {
    "codigo": "VN",
    "nome": "Vietnã"
  },
  {
    "codigo": "ZM",
    "nome": "Zâmbia"
  },
  {
    "codigo": "ZW",
    "nome": "Zimbábue"
  }
];
